.wrapper {
    display: flex;
    gap: 0.45rem;
    --gen-btn-orange: #f2864f;
    --gen-btn-orange-hover: #ea7738;
}

.button {
    background-color: white;
    border: 1px solid #222;
    border-radius: 0.2rem;
    color: inherit;
    cursor: pointer;
    flex: 1;
    font-family: inherit;
    font-size: 0.9rem;
    padding: 0.35rem 0.45rem;
}

.button:hover,
.button:focus,
.button:active {
    background-color: rgb(0 0 0 / 10%);
}

.button:first-of-type {
    background-color: var(--gen-btn-orange);
    border-color: var(--gen-btn-orange);
    color: white;
}

.button:first-of-type:hover,
.button:first-of-type:focus,
.button:first-of-type:active {
    background-color: var(--gen-btn-orange-hover);
    border-color: var(--gen-btn-orange-hover);
}

.button:only-of-type {
    font-weight: 700;
    padding: 0.9rem 0;
}
